import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { HttpRequest } from '@angular/common/http';

import { LoadState } from '@app/authenticated/profile/ui/profile.enum';
import { UserProfileControllerService } from '@app/generated/services/user-profile-controller.service';
import { TwoFactorService } from '@app/authentication/shared/services/two-factor.service';
import { TwoFactorType } from '@app/authentication/shared/api/two-factor.api';

const lengthValidatorErrorTypes = ['minlength', 'maxlength'];

@Component({
  template: '',
  standalone: false,
})
export class ProfileBaseComponent implements OnInit {
  protected readonly loadStateEnum = LoadState;
  protected readonly twoFactorTypeEnum = TwoFactorType;
  protected twoFactorType?: TwoFactorType;
  protected originalRequest?: HttpRequest<any>;

  constructor(
    protected readonly translateService: TranslateService,
    protected readonly toastrService: ToastrService,
    protected readonly twoFactorService: TwoFactorService,
    protected readonly userProfileControllerService: UserProfileControllerService,
  ) {}

  ngOnInit(): void {}

  createErrorMessageGetter(
    formControl: FormControl,
    errorMessages: Record<string, string> = {},
  ): () => string | undefined {
    return () => {
      const errors = formControl.errors;
      const firstError = errors && Object.entries(errors);
      if (!firstError) return;

      const [errorCode, error] = firstError[0];
      const errorMessage = errorMessages[errorCode];
      const errorAdditionalInfo = this.resolveErrorAdditionalInfo(errorCode, error);
      return errorAdditionalInfo ? this.translateService.instant(errorMessage, errorAdditionalInfo) : errorMessage;
    };
  }

  createValidStateGetter = (formControl: FormControl): (() => boolean) => {
    return () => {
      return formControl?.pristine || formControl?.valid;
    };
  };

  private resolveErrorAdditionalInfo(errorCode: string, error: boolean | Record<string, any>) {
    const isErrorObject = typeof error === 'object' && error !== null;
    if (isErrorObject) {
      if (lengthValidatorErrorTypes.includes(errorCode)) {
        return {
          // renamed the key according to the value in the translation definitions
          value: error.requiredLength,
        };
      }
      return error.additionalInfo;
    }
    return null;
  }
}
